import store from '../store'

export default async (to, from, next) => {
    if (store.getters['auth/check']) {

        if (store.getters['auth/user'].subscription_status == "152")
            next({name: 'waiting'})

    }
    next();

}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js